import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 5FEBC8BB-061B-4D91-BD96-88285B5C2E23
 * name align-horizontal-right
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-horizontal-right.svg
 * tags
 */
export const AlignHorizontalRightIcon = createSvgIcon(<><path d="M20 2H22V22H20V2M2 10H18V7H2V10M8 17H18V14H8V17Z" /></>, 'AlignHorizontalRightIcon');
export default AlignHorizontalRightIcon